import React from 'react';
import FinanceList from '../office/FinanceList';

const StoreKeeperOfficeManagement: React.FC = () => {
  return <FinanceList />;
};

export default StoreKeeperOfficeManagement; 